import ArrayType from './array';
import DefaultType from './default';
import ObjectType from './object';

export default {
  Array: ArrayType,
  Default: DefaultType,
  Object: ObjectType,
};
